import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
  margin-left: 10px;
`;

export const Label = styled.div`
  color: ${({ theme }) => {
    return theme.colors.darkgrey;
  }};
  text-align: left;
  font: normal normal normal 16px/22px Open Sans;
  letter-spacing: 0px;
`;
